import React from 'react';
import { FaStar, FaWhatsapp, FaInstagram } from 'react-icons/fa';
import { BsCheckAll } from 'react-icons/bs';

const reviews = [
    {
        id: 1,
        platform: 'whatsapp',
        name: 'Muneera',
        location: 'kozhikode',
        event: 'Bridal Mehandi',
        initials: 'FR',
        color: '#A0522D',
        time: '10:24 AM',
        rating: 5,
        message: 'Adila put Mehandi for my daughters.Loved it ♥️soo preety, beautiful work dear.😍😍Thanks you sooo much😘😘😘',
    },
    {
        id: 2,
        platform: 'instagram',
        name: 'Jinisha',
        displayName: 'Jinisha',
        location: 'Kozhikode',
        event: 'Arabic Mehandi',
        initials: 'AM',
        color: '#C9A96E',
        time: '2d',
        rating: 5,
        likes: 47,
        message: 'Eid nu mehandi idan ullavar pettanu book cheitholu, I loved this, Adila yude work adipoli anu, edu design anelum avalk simple and finishing is amazing, My mom already booked her for Eid and coming programs♥️',
    },
    {
        id: 3,
        platform: 'whatsapp',
        name: 'Adila ibrahim',
        location: 'Malappuram',
        event: 'Traditional Mehandi',
        initials: 'PN',
        color: '#6B5B95',
        time: '3:15 PM',
        rating: 5,
        message: 'nalla stain aayrnn tto💞💞And texture was super adipoli Athrem smooth aayttaa henna varunnath Easy aayi idaan pattnd for a beginner like me😄',
    },
    {
        id: 4,
        platform: 'instagram',
        name: 'zara.khan__',
        displayName: 'Zara Khan',
        location: 'Kondotty',
        event: 'Bridal Mehandi',
        initials: 'ZK',
        color: '#E8935A',
        time: '5d',
        rating: 5,
        likes: 83,
        message: "Ya Allah what beautiful work 😭❤️ The bridal set took my breath away! Every design was unique and she listened to exactly what I wanted. If you're getting married in Kerala, this is your girl! 🌸🌿",
    },
    {
        id: 5,
        platform: 'whatsapp',
        name: 'Meera Suresh',
        location: 'Tirur',
        event: 'Eid Special',
        initials: 'MS',
        color: '#2E8B57',
        time: '11:00 AM',
        rating: 5,
        message: 'Booked for Eid celebration and the work was phenomenal 🎊 Quick, neat and such beautiful patterns. The stain came out a gorgeous deep brown 🤎 Will always be my go-to mehandi artist! Highly recommended to all!',
    },
    {
        id: 6,
        platform: 'whatsapp',
        name: 'Nadia Faisal',
        location: 'Calicut',
        event: 'Engagement Ceremony',
        initials: 'NF',
        color: '#B8860B',
        time: '6:48 PM',
        rating: 5,
        message: 'I was amazed by the creativity and skill 😍 She transformed my hands into a work of art. The designs were unique and she was so patient with all my requests. Truly a gifted artist! Thank you so much 💕',
    },
];

function StarRating({ rating }) {
    return (
        <div className="msg-stars">
            {[...Array(5)].map((_, i) => (
                <FaStar
                    key={i}
                    style={{
                        color: i < rating ? '#C9A96E' : 'rgba(201,169,110,0.25)',
                        fontSize: 12,
                    }}
                />
            ))}
        </div>
    );
}

function WhatsAppCard({ review }) {
    return (
        <div className="msg-card wa-card">
            {/* WA chrome header */}
            <div className="wa-header">
                <div className="wa-avatar" style={{ background: review.color }}>
                    {review.initials}
                </div>
                <div className="wa-contact-info">
                    <span className="wa-name">{review.name}</span>
                    <span className="wa-sub">{review.event} &bull; {review.location}</span>
                </div>
                <FaWhatsapp className="platform-icon wa-icon" />
            </div>

            {/* Chat body */}
            <div className="wa-body">
                <div className="wa-bubble">
                    <p className="wa-text">{review.message}</p>
                    <div className="wa-footer-inline">
                        <span className="wa-time">{review.time}</span>
                        <BsCheckAll className="wa-ticks" />
                    </div>
                </div>
            </div>

            {/* Rating strip */}
            <div className="msg-rating-row">
                <StarRating rating={review.rating} />
                <span className="msg-badge wa-badge">
                    <FaWhatsapp style={{ fontSize: 10, marginRight: 4 }} />
                    WhatsApp
                </span>
            </div>
        </div>
    );
}

function InstagramCard({ review }) {
    return (
        <div className="msg-card ig-card">
            {/* IG chrome header */}
            <div className="ig-header">
                <div className="ig-avatar-ring">
                    <div className="ig-avatar" style={{ background: review.color }}>
                        {review.initials}
                    </div>
                </div>
                <div className="ig-contact-info">
                    <span className="ig-username">{review.name}</span>
                    <span className="ig-display">{review.displayName} &bull; {review.location}</span>
                </div>
                <FaInstagram className="platform-icon ig-icon" />
            </div>

            {/* DM body */}
            <div className="ig-body">
                <div className="ig-bubble">
                    <p className="ig-text">{review.message}</p>
                </div>
                <div className="ig-meta">
                    <span className="ig-time">{review.time} ago</span>
                    {review.likes && (
                        <span className="ig-likes">❤️ {review.likes} likes</span>
                    )}
                </div>
            </div>

            {/* Rating strip */}
            <div className="msg-rating-row ig-rating-row">
                <StarRating rating={review.rating} />
                <span className="msg-badge ig-badge">
                    <FaInstagram style={{ fontSize: 10, marginRight: 4 }} />
                    Instagram
                </span>
            </div>
        </div>
    );
}

function ReviewsComponent() {
    return (
        <section className="reviews-section" id="Reviews">
            <div className="section-ornament">
                <span className="ornament-line"></span>
                <span className="ornament-diamond"></span>
                <span className="ornament-line"></span>
            </div>

            <div className="container">
                <div className="text-center mb-5">
                    <span className="section-label">Testimonials</span>
                    <h2 className="section-title">What Our Clients Say</h2>
                    <p className="section-subtitle">
                        Real messages from our happy clients — unedited
                    </p>
                </div>

                <div className="msgs-grid">
                    {reviews.map(r =>
                        r.platform === 'whatsapp'
                            ? <WhatsAppCard key={r.id} review={r} />
                            : <InstagramCard key={r.id} review={r} />
                    )}
                </div>
            </div>

            <div className="section-ornament mt-4">
                <span className="ornament-line"></span>
                <span className="ornament-diamond"></span>
                <span className="ornament-line"></span>
            </div>
        </section>
    );
}

export default ReviewsComponent;
